import TotalPrice from "./totalPrice";

export default class ProductAttribute {

    constructor(product, data) {
        this.product = {};
        Object.assign(this.product, product);

        delete (this.product.attributes);
        this.attribute = {
            id: null,
            name: '',
            values: {}
        };

        this.multiple = false;
        this.quantity_multiplier = 1;
        this.selectedAttributeValues = [];
        this.checkedAttributeValues = [];
        this.isValid = true;

        Object.assign(this, data);

        this.valuesPositions = [];
        if (data.attribute.values) {
            for (let value of data.attribute.values) {
                this.valuesPositions[value.id] = value.pivot.position;
            }
        }

        this.valuesMap = new Map();
        this.quantity_multiplier = parseInt(this.quantity_multiplier);
        this.productAttributeValues = [];
    }

    sortValues() {
        this.productAttributeValues.sort((v1, v2) => {
            const pos1 = this.valuesPositions[v1.id] ? this.valuesPositions[v1.id] : 0;
            const pos2 = this.valuesPositions[v2.id] ? this.valuesPositions[v2.id] : 0;
            if (v1.custom && !v2.custom) {
                return 1;
            }
            if (v2.custom && !v1.custom) {
                return -1;
            }
            if (v2.custom && v1.custom) {
                return 0;
            }
            if (pos1 === pos2) {
                if (v1.name > v2.name) {
                    return 1;
                } else if (v1.name < v2.name) {
                    return -1;
                } else if (v1.name === v2.name) {
                    return 0;
                }
            }
            if (pos1 > pos2) {
                return 1;
            } else if (pos1 < pos2) {
                return -1;
            }
            return 0;
        });
    }

    addProductAttributeValue(productAttributeValue) {
        this.productAttributeValues.push(productAttributeValue);
        this.valuesMap.set(productAttributeValue.id, productAttributeValue);
    }

    getTotalPrice() {

        let totalPrice = new TotalPrice(this.product.prices.currency, this.product.prices.tax_rate);

        this.selectedAttributeValues.forEach(attributeValue => {
            if (attributeValue.prices.price) {
                totalPrice.price.add(parseFloat(attributeValue.prices.price) * (attributeValue.quantity ? attributeValue.quantity : attributeValue.quantityMultiplier));
            }
            if (attributeValue.prices.promo_price) {
                totalPrice.promoPrice.add(parseFloat(attributeValue.prices.promo_price) * (attributeValue.quantity ? attributeValue.quantity : attributeValue.quantityMultiplier));
            } else {
                totalPrice.promoPrice.add(parseFloat(attributeValue.prices.price) * (attributeValue.quantity ? attributeValue.quantity : attributeValue.quantityMultiplier));
            }
        });

        return totalPrice;
    }

    selectAttributeValue() {
        this.selectedAttributeValues = [];
        this.checkedAttributeValues.forEach((attributeId, valueId) => {
            if (attributeId) {
                this.selectedAttributeValues.push(this.valuesMap.get(attributeId));
            }
        });
        this.validate();
    }

    getOtherValuesFromSelectedAttributes() {
        return this.selectedAttributeValues.filter(value => {
            return value.custom === 1;
        });
    }

    getValueColor(attributeValue) {
        if (!attributeValue.color) {
            attributeValue.color = 'hsl(' + Math.round(Math.random() * 255) + ', 30%, 60%)';
        }

        return attributeValue.color;
    }

    validate() {
        this.isValid = !!this.multiple || this.checkedAttributeValues.length > 0;

        return this.isValid;
    }

    hasPrice() {
        return !!this.productAttributeValues.find(attributeValue => attributeValue.prices && attributeValue.prices.price > 0);
    }

    getDefaultPrice() {
        const productAttributeValue = this.productAttributeValues.find(attributeValue => attributeValue.prices);

        return new TotalPrice(productAttributeValue.prices.currency, productAttributeValue.prices.tax_rate, 0, 0);
    }

    get hasSelectedIndividualAttributeValue() {
        return !!this.selectedAttributeValues.find(selectedAttributeValue => {
            return selectedAttributeValue.custom === 2;
        });
    }

}
